// @flow weak

import _ from 'lodash';

import { connectedTrackOnMount } from 'app/common/components/TrackOnMount';

export const connectedTrackModalOnMount = (
  computeTrackingEventData,
  shouldTrack = () => true
) =>
  connectedTrackOnMount(
    'Modal: shown',
    props =>
      _.merge(
        { path: window.location.pathname },
        computeTrackingEventData(props)
      ),
    shouldTrack
  );
